import { HeadingSection } from './default';
export * from './topmodels';
export * from './default';
export * from './components';
export default HeadingSection;
